import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';

import { ConfirmDialogData } from '@intranet/components/dialog/confirm-dialog/confirm-dialog.component';
import { switchMap } from 'rxjs';
import {
    User,
    UserGroup,
    UserRoleMember,
} from '@intranet/modules/users/user.types';
import { HotkeyService } from 'src/app/core/services/hotkey.service';
import { JobService, JobType } from '@intranet/modules/jobs';

@Component({
    selector: 'admin-jobtype',
    templateUrl: './admin-jobtype-manage.component.html',
    styleUrls: ['./admin-jobtype-manage.component.scss'],
})
export class AdminJobTypeManageComponent implements OnInit {
    @Input() jobType: JobType | null;
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() update: EventEmitter<JobType> = new EventEmitter<JobType>();
    @ViewChild('form') jobTypeForm: NgForm;


    title: string;
    isLoading: boolean = false;
    error: string | null;
    isCreate: boolean = false;
    confirmDialog: ConfirmDialogData = new ConfirmDialogData();

    constructor(
        private jobService: JobService,
        private router: Router,
        private route: ActivatedRoute,
        private hotkeyService: HotkeyService
    ) {}

    ngOnInit(): void {
        // Register hotkey for "Cancel" action (Ctrl + Q)
        this.hotkeyService.registerHotkey('ctrl+q', 'Cancel action', () => this.onCancel());

        // Register hotkey for "Save" action (Ctrl + Alt + S)
        this.hotkeyService.registerHotkey('ctrl+alt+s', 'Save changes', () => {
          if (this.jobTypeForm?.valid && !this.jobTypeForm?.pristine) {
              this.onSubmit();
          }
      });

        this.route.paramMap
            .pipe(
                switchMap((p) => {
                    const typeId = this.jobType?.jobTypeId ?? 0;
                    if (!typeId) {
                        this.title = 'Add job type';
                    } else {
                        this.title = 'Edit job type';
                    }

                    return this.jobService.getJobTypeToEdit(typeId);
                })
            )
            .subscribe({
                next: response => {
                    if (response.success === false) {
                        this.error = response.error || 'Failed to load job type data.';
                        return;
                    }

                    this.jobType = response.jobType;
                    this.isCreate = response.isCreate;
                },
                error: (error) => {
                    this.error = error;
                },
            });
    }

    onSubmit() {
        if (!this.jobType) {
            return;
        }

        // const result$ = this.isCreate
        //     ? this.userService.addNewUserGroup(
        //           this.userGroup
        //       )
        //     : this.userService.updateUserGroup(this.userGroup);
        
        this.jobService.addOrUpdateJobType(this.jobType).subscribe({
                next: (res) => {
                    if (!res.success) {
                        this.error = res.error;
                    } else {
                        this.update.emit(this.jobType);
                        this.closeDialog();
                    }
                },
                error: (error) => {
                    this.error = error;
                }
            }
        );
    }


    onCancel() {
        this.closeDialog();
    }

    closeDialog() {
        this.close.emit(false);
    }
}
